// src/components/Course/StudentCourseItem.tsx
import React from 'react';
import { Course } from '../../types/interfaces';
import { Card, CardContent, Typography, CardActions, Button } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

const StudentCourseItem: React.FC<{ course: Course }> = ({ course }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/course/${course.id}`);
  };

  const handleCardKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleCardClick();
    }
  };

  return (
    <Card
      sx={{ cursor: 'pointer' }}
      onClick={handleCardClick}
      onKeyDown={handleCardKeyDown}
      role="button"
      tabIndex={0}
    >
      <CardContent>
        <Typography variant="h5" component="div">
          {course.name}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {course.description}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {course.startDate} - {course.endDate}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" component={RouterLink} to={`/course/${course.id}`} onClick={(event) => event.stopPropagation()}>
          Näytä
        </Button>
      </CardActions>
    </Card>
  );
};

export default StudentCourseItem;
